import { Component, Prop, Vue } from 'vue-property-decorator';
import EventBus from '@/helpers/EventBus';
import LoginFlowStepEmail from '@/components/forms/LoginFlowStepEmail.vue';
import LoginFlowStepOTP from '@/components/forms/LoginFlowStepOTP.vue';
import LoginFlowStepOTPUnavailable from '@/components/forms/LoginFlowStepOTPUnavailable.vue';
import LoginFlowStepPassword from '@/components/forms/LoginFlowStepPassword.vue';
import store from '@/store/store';
@Component({
    name: 'LoginFlow',
    components: { LoginFlowStepEmail, LoginFlowStepPassword, LoginFlowStepOTP, LoginFlowStepOTPUnavailable },
})
export default class default_1 extends Vue {
    @Prop()
    hideForgotLink;
    @Prop()
    showBecomeMemberLink;
    step = 'email';
    mounted() {
        EventBus.$on('request-code-link-clicked', this.backToEmail);
        this.checkIsMagicLink();
    }
    destroyed() {
        store.dispatch('LoginFlow/clearAll');
    }
    goToStep(step) {
        this.step = step;
    }
    backToEmail() {
        this.goToStep('email');
    }
    checkIsMagicLink() {
        // We only trigger the magic link flow when this form is rendered in the modal. This is done to avoid the home/membership page ('/') login form from consuming the code and presenting a bad UX, since the magic link in the email contains the `?login=1` param that opens the modal. Opening the modal is a more general solution that applies for all tenants, including those that don't have a home/membership page.
        const isInModal = document.querySelector('dialog')?.contains(this.$el);
        const isFromMagicLink = this.$route.query.otp;
        if (isFromMagicLink && isInModal) {
            const loginFlowData = store.getters['LoginFlow/all'];
            const { email, token, redirectPath } = loginFlowData;
            const hasAllOTPData = email && token && redirectPath;
            this.goToStep(hasAllOTPData ? 'otp_form' : 'otp_unavailable');
        }
    }
}
